module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('x-header', [_vm._v("\n    " + _vm._s(_vm.middleBackText2) + "\n    "), _c('span', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.showMenus = true
      }
    },
    slot: "right"
  }, [_vm._v("我的")])]), _vm._v(" "), (Object.keys(_vm.list).length > 1) ? _c('div', {
    staticClass: "flex-header shop-header"
  }, [_c('button-tab', _vm._l((_vm.list), function(item) {
    return _c('button-tab-item', {
      key: item.id,
      attrs: {
        "selected": _vm.selectId == item.id
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectId = item.id
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-content",
    domProps: {
      "innerHTML": _vm._s(_vm.detailForShow)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foot-button"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClickBuy($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.buyModifyBtnText))])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToCart($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.goButton))])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('popup', {
    attrs: {
      "hide-on-blur": false
    },
    model: {
      value: (_vm.showChooseBox),
      callback: function($$v) {
        _vm.showChooseBox = $$v
      },
      expression: "showChooseBox"
    }
  }, [_c('div', {
    staticClass: "pop"
  }, [_c('flexbox', [_c('div', {
    staticClass: "mini-logo-box"
  }, [_c('img', {
    staticStyle: {
      "width": "50px",
      "height": "50px"
    },
    attrs: {
      "src": _vm.smallThumb
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-amount"
  }, [_vm._v(_vm._s(_vm.info))])]), _vm._v(" "), _c('div', {
    staticClass: "pop-body"
  }, [_c('group', [_c('div', {
    staticClass: "choose-type"
  }, _vm._l((_vm.list), function(item) {
    return _c('x-button', {
      key: item.id,
      staticStyle: {
        "width": "100px",
        "padding": "0 0"
      },
      attrs: {
        "type": _vm.selectId == item.id ? 'warn' : 'default',
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSelectedProductId(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n                "), (_vm.productsAmount[item.id]) ? _c('badge', {
      attrs: {
        "text": _vm.productsAmount[item.id]
      }
    }) : _vm._e()], 1)
  }))]), _vm._v(" "), _c('group', [_c('div', {
    staticClass: "quick-choose-num"
  }, [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.setNum(0)
      }
    }
  }, [_vm._v("不选")]), _vm._v(" "), _vm._l((_vm.amountPriceMapping), function(item, index) {
    return _c('x-button', {
      key: index,
      attrs: {
        "mini": "",
        "disabled": item.amount > _vm.maxAmount
      },
      nativeOn: {
        "click": function($event) {
          _vm.setNum(item.amount)
        }
      }
    }, [_vm._v(_vm._s(item.amount) + _vm._s(_vm.unit) + "\n              ")])
  })], 2), _vm._v(" "), _c('x-number', {
    attrs: {
      "min": 0,
      "max": _vm.maxAmount,
      "step": _vm.step,
      "title": "数量",
      "width": "100px"
    },
    model: {
      value: (_vm.productsAmount[_vm.selectId]),
      callback: function($$v) {
        _vm.$set(_vm.productsAmount, _vm.selectId, $$v)
      },
      expression: "productsAmount[selectId]"
    }
  })], 1), _vm._v(" "), _c('group', [_c('div', {
    staticStyle: {
      "padding": "15px 20px 0"
    }
  }, [_c('span', [_vm._v(" 单价：¥ " + _vm._s(_vm.price) + " 元")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("总价：¥ " + _vm._s((_vm.price * _vm.totalSelectedProductNum).toFixed(2)) + " 元")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pop-foot"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "warn",
      "disabled": _vm.canNotSubmit
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitToCart($event)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.submitBtnText) + " "), (_vm.canNotSubmit === false && _vm.totalSelectedProductNum > 0) ? _c('span', [_vm._v(" ( " + _vm._s(_vm.totalSelectedProductNum) + " " + _vm._s(_vm.unit) + " ) ")]) : _vm._e()])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "show": _vm.showLoading,
      "text": _vm.loadingText
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('actionsheet', {
    attrs: {
      "menus": _vm.menus,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.handleActionSheet
    },
    model: {
      value: (_vm.showMenus),
      callback: function($$v) {
        _vm.showMenus = $$v
      },
      expression: "showMenus"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6799c91d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/Cate.vue
// module id = 705
// module chunks = 0